import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  EDITSUBSCRIPTION,
  SUBSCRIPTIONDETAIL,
} from "../../../../store/subscription/actions";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import {
  editTokenPlan,
  tokenDetail,
  tokenList,
} from "../../../../store/tokens/actions";

const EditTokenPlan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading } = useSelector((state) => state.Tokens);

  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const [formData, setFormData] = useState({
    id: id,
    name: "",
    price: "",
    perTokenPrice: "",
    tokens: "",
    status: "active",
    discountPrice: "",
    discountPercentage: "",
  });

  // ── Fetch plan details ──
  const getPlanDetails = () => {
    const callback = (err, res) => {
      if (err) {
        console.error(err);
        toast.error(err);
      } else {
        const plan = res.data;
        console.log(plan, "planasdf");
        setFormData({
          id: plan?._id || "",
          name: plan?.name || "",
          price: plan?.price ?? "",
          perTokenPrice: plan?.perTokenPrice ?? "",
          tokens: plan?.tokens ?? "",
          status: plan?.status || "active",
          discountPrice: plan?.discountPrice ?? "",
          discountPercentage: plan?.discountPercentage ?? "",
        });
      }
    };
    dispatch(tokenDetail({ data: id, callback }));
  };

  useEffect(() => {
    getPlanDetails();
  }, []);

  // ── Global field handler ──
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "number") {
      if (value === "") {
        setFormData({ ...formData, [name]: "" });
        setErrors({ ...errors, [name]: "" });
        return;
      }
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) return;
      setFormData({ ...formData, [name]: numericValue });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }

    setErrors({ ...errors, [name]: "" });
  };

  // ── Validation ──
  const validateFormData = () => {
    const newErrors = {};

    if (!formData.name || !formData.name.trim())
      newErrors.name = "Name is required";

    if (formData.price === "" || formData.price === null)
      newErrors.price = "Price is required";

    if (formData.perTokenPrice === "" || formData.perTokenPrice === null)
      newErrors.perTokenPrice = "Per token price is required";

    if (formData.tokens === "" || formData.tokens === null)
      newErrors.tokens = "Tokens is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ── Submit ──
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);

    if (!validateFormData()) {
      setIsDisabled(false);
      return;
    }

    try {
      // Strip empty optional fields before sending
      const payload = { ...formData };
      if (payload.discountPrice === "") delete payload.discountPrice;
      if (payload.discountPercentage === "") delete payload.discountPercentage;

      const callback = (err) => {
        if (err) {
          toast.error(err);
          console.error(err);
        } else {
          toast.success("Token Plan Updated Successfully");
          navigate("/tokens-setting");
        }
        setIsDisabled(false);
      };

      dispatch(editTokenPlan({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
      setIsDisabled(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form className="mx-auto" onSubmit={handleSubmit}>
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Edit Token Plan:
                      </h5>
                    </div>

                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        {/* Name — required */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Enter plan name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </Col>

                        {/* Status */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Status
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </Col>

                        {/* Price — required */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Price <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="price"
                            placeholder="Enter price"
                            value={formData.price}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.price && (
                            <small className="text-danger">
                              {errors.price}
                            </small>
                          )}
                        </Col>

                        {/* Tokens — required */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Tokens <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="tokens"
                            placeholder="Enter tokens"
                            value={formData.tokens}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.tokens && (
                            <small className="text-danger">
                              {errors.tokens}
                            </small>
                          )}
                        </Col>

                        {/* Per Token Price — required */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Per Token Price{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="perTokenPrice"
                            placeholder="Enter per token price"
                            value={formData.perTokenPrice}
                            onChange={handleChange}
                            min="0"
                            step={"any"}
                          />
                          {errors.perTokenPrice && (
                            <small className="text-danger">
                              {errors.perTokenPrice}
                            </small>
                          )}
                        </Col>

                        {/* Discount Price — optional */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Discount Price{" "}
                            <span className="text-muted fw-normal text-lowercase">
                              (optional)
                            </span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="discountPrice"
                            placeholder="Enter discount price"
                            value={formData.discountPrice}
                            onChange={handleChange}
                            min="0"
                          />
                        </Col>

                        {/* Discount Percentage — optional */}
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Discount Percentage{" "}
                            <span className="text-muted fw-normal text-lowercase">
                              (optional)
                            </span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="discountPercentage"
                            placeholder="Enter discount %"
                            value={formData.discountPercentage}
                            onChange={handleChange}
                            min="0"
                            max="100"
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>

                  {/* Submit / Cancel */}
                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="text-uppercase fw-sbold w-100 btn-danger"
                            onClick={() => navigate("/subscription-setting")}
                            type="button"
                          >
                            Cancel
                          </Button>
                        </Col>
                        <Col md="7" className="my-2">
                          <Button
                            disabled={isDisabled}
                            type="submit"
                            className="text-uppercase fw-sbold w-100 btn-primary"
                          >
                            {isDisabled ? "Updating..." : "Update"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EditTokenPlan;
